/**
 * Attendance model translations (sidebar link)
 *
 * Translation keys follow the pattern: models.attendance.{category}.{key}
 */
export default {
  en: {
    singular: "Attendance",
    plural: "Attendance",
  },

  fr: {
    singular: "Présence",
    plural: "Présences",
  },
};
